'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionTitle = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    font-weight: 300;\n    font-size: 1.8em;\n    line-height: 1.25em;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    ', '\n'], ['\n    ', '\n    font-weight: 300;\n    font-size: 1.8em;\n    line-height: 1.25em;\n    margin-top: 0;\n    margin-bottom: 0;\n\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: ', 'em;\n  '], ['\n    font-size: ', 'em;\n  ']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SectionTitle = exports.SectionTitle = _styledComponents2.default.h2(_templateObject, function (_ref) {
  var _ref$center = _ref.center,
      center = _ref$center === undefined ? true : _ref$center;
  return center ? 'text-align: center;' : 'text-align: left;';
}, function (_ref2) {
  var simple = _ref2.simple;
  return simple ? 'margin-bottom: 0.5em;' : '&:after {\n            content: \'\';\n            display: block;\n            width: 3em;\n            position: relative;\n            left: 50%;\n            margin-top: 0.5em;\n            margin-left: -1.5em;\n            margin-bottom: 0.75em;\n            border-bottom: solid 1px ' + _styles.styles.colors.title_decoration + ';\n        }';
});
// eslint-disable-next-line no-magic-numbers
[1, 2, 3, 4, 5, 6].forEach(function (level) {
  // eslint-disable-next-line no-magic-numbers
  var fontSize = [2, 1.7, 1.5, 1.2, 1.1, 1];
  var hlevel = 'h' + level;
  SectionTitle[hlevel] = SectionTitle.withComponent(hlevel).extend(_templateObject2, fontSize[level - 1]);
  SectionTitle[hlevel].displayName = 'SectionTitle.' + hlevel;
});
SectionTitle.displayName = 'SectionTitle';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/SectionTitle.js
// module id = 52
// module chunks = 0